export enum SearchResultSectionType {
	recentVisited = 'recentVisited',
	recentSearches = 'recentSearches',
	searchResults = 'searchResults',
	popular = 'popular',
}
export type SearchResultSection<T> = {
	key: SearchResultSectionType;
	title: string;
	items: T[];
};
